import routerOptions0 from "/unified-client/node_modules/.pnpm/nuxt@3.21.4_@parcel+watcher@2.5.6_@types+node@24.12.2_@vue+compiler-sfc@3.5.33_cac@6.7._46b16e96619e5cfe2cc2b5109133eb96/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}